import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { CampaignEngagement } from '../outreachTypes';
import { useRetry } from './useRetry';

/**
 * `outreach.campaigns.engagement` (design outreach s1): the clicks by service and the listen depth
 * of one campaign. `outreach.campaign.updated` reads it again.
 */
export function useCampaignEngagement(accountId: number, campaignUuid: string) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.engagement.queryOptions({ accountId, campaignUuid }, { retry: false })
  );
  const retry = useRetry(query.refetch);
  return {
    engagement: (query.data ?? undefined) as CampaignEngagement | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
